module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/shampoo-cf7c7a165e4e3345d0005513d6dd9b85.svg";